const SECURITY_API = 'https://s0blefoi3a.execute-api.us-east-1.amazonaws.com/dev';
const BASE_API_RU = 'https://mx3szfpt1h.execute-api.us-east-1.amazonaws.com/v1';

export const environment = {
  production: false,
  env: 'dev',
  ENDPOINTS: {
    SECURITY: SECURITY_API, // encrypt, decrypt
    BASE_RU: BASE_API_RU,
  },
  AWS_CONFIG: {
    credentials: {
      identityPool: "us-east-1:af38c276-f042-4b69-a0a8-c2e52137fd06", //prod
      region: 'us-east-1',
      structureBucket: 'dev.structure.files',
      bucketFiles: 'dev.survey.files',
    },
  },
  PARENT_ORIGINS: [
    "http://localhost:4200",
    "http://localhost:4400"
  ],
};

/*
 * For easier debugging in development mode, you can import the following filee
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
